<template>
  <span class="converted-badge" :class="{ converted: value == 1, contact: value != 1 && status === 'in_contact' }">{{ value == 1 ? 'Converted' : status === 'in_contact' ? 'In Contact' : 'Not Converted' }}</span>
</template>

<script>
export default {
  name: 'ConvertedBadge',
  props: { value: { type: [Boolean, Number, String], default: false }, status: { type: String, default: '' } }
}
</script>

<style scoped>
.converted-badge { display: inline-flex; align-items: center; font-size: 12px; font-weight: 700; padding: 4px 10px; border-radius: 999px; white-space: nowrap; background: #f3f4f6; color: #6b7280; border: 1px solid #e5e7eb; }
.converted-badge.converted { background: #eff6ff; color: #1d4ed8; border-color: #bfdbfe; }
.converted-badge.contact { background: #fef3c7; color: #92400e; border-color: #fde68a; }
</style>
